export const permissions = [
  {
    id: 1,
    name: "admin",
    role: "0",
    b_id: ["0"],
  },
  {
    id: 2,
    name: "staff",
    role: "0",
    b_id: ["1", "2", "3", "4", "5", "6", "7", "8"],
  },
  {
    id: 3,
    name: "approver",
    role: "2",
    b_id: ["1", "2", "3", "4", "5", "6", "7", "8"],
  },

  {
    id: 4,
    name: "supervisor",
    role: "1",
    b_id: ["1", "2", "3", "4", "5", "6", "7", "8"],
  },
  {
    id: 5,
    name: "student",
    role: "",
    b_id: ["1", "2", "3", "4", "5", "6", "7", "8"],
  },
 
];
